import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacyOptionModule as MatOptionModule } from '@angular/material/legacy-core';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyPaginatorModule as MatPaginatorModule } from '@angular/material/legacy-paginator';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacySnackBarModule as MatSnackBarModule } from '@angular/material/legacy-snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatLegacyTabsModule as MatTabsModule } from '@angular/material/legacy-tabs';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { UtilitiesModule } from '@ebootis/utilities';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../shared/shared.module';
import { CustomerEditComponent } from './components/customer-edit/customer-edit.component';
import { CustomerSearchComponent } from './components/customer-search/customer-search.component';
import { CustomerDialog, CustomerSelectComponent } from './components/customer-select/customer-select.component';
import { CustomerDeleteDialog, CustomerTableComponent } from './components/customer-table/customer-table.component';
import { CustomerComponent } from './components/customer/customer.component';

@NgModule({
    declarations: [
        CustomerComponent,
        CustomerEditComponent,
        CustomerSearchComponent,
        CustomerTableComponent,
        CustomerSelectComponent,
        CustomerDialog,
        CustomerDeleteDialog,
    ],
    imports: [
        ReactiveFormsModule,
        CommonModule,
        MatTabsModule,
        MatFormFieldModule,
        MatOptionModule,
        MatSelectModule,
        MatTableModule,
        MatIconModule,
        MatPaginatorModule,
        MatInputModule,
        MatButtonModule,
        MatSnackBarModule,
        MatRadioModule,
        TranslateModule.forChild(),
        MatTooltipModule,
        MatCardModule,
        SharedModule,
        UtilitiesModule,
        MatDialogModule,
        MatAutocompleteModule,
        MatSortModule,
        MatCheckboxModule
    ],
    exports: [
        CustomerComponent,
        CustomerEditComponent,
        CustomerSearchComponent,
        CustomerSelectComponent,
        CustomerTableComponent
    ]
})
export class CustomerModule { }
